module.exports = __webpack_public_path__ + "img/loginbg.d87b3c43.png";